export default __webpack_public_path__ + "static/media/audio_06_rio_con_rocas.988ad20f.mp3";